import * as React from 'react';
import Block from './Block';
import { Section, Container, Loader } from '../modules';

interface IPlaceholderProps {
    type: string;
}

const Placeholder = (props: IPlaceholderProps) => {
    const { type } = props;

    switch (type) {
        case 'productDetail':
            return (
                <React.Fragment>
                    <Block h={40}/>
                    <div className="productDetail">
                        <div className="productDetail__gallery">
                            <Block type="detailImage"/>
                        </div>
                        <div className="productDetail__overview">
                            {/* <Block w={110} h={60} mb={30}/> */}
                            <Block w={300} h={30} mb={20}/>
                            <Block w={140} h={30} mb={10}/>
                            <Block w={110} h={30} mb={30}/>
                            <Block w={120} h={25} mb={10}/>
                            <Block type="wrap" mb={25}>
                                <Block w={50} h={25} mr={5}/>
                                <Block w={50} h={25}/>
                            </Block>
                            <Block type="wrap" mb={25}>
                                <Block w={270} h={55} mr={5}/>
                                <Block w={55} h={55}/>
                            </Block>
                            <Block w={220} h={20} mb={10}/>
                            <Block w={160} h={20} mb={10}/>
                        </div>
                    </div>
                </React.Fragment>
            );
        case 'productListFilters':
            return (
                <React.Fragment>
                    <Block type="wrap" mt={24} mb={10}>
                        <Block w={250} h={40} mr={20}/>
                        <Block w={250} h={40}/>
                    </Block>
                </React.Fragment>
            );
        case 'products':
            return (
                <React.Fragment>
                    <div className="productList mt-3">
                        <Container>
                            <div className="productList__grid">
                                {Array.from(Array(24).keys()).map((v, i) => (
                                    <div key={i} className="productList__item mb-5">
                                        <Block w={300} h={250} mb={30} mt={40} />
                                        <Block w={100} h={20} mb={10} />
                                        <Block w={50} h={20} mb={10} />
                                    </div>
                                ))}
                            </div>
                        </Container>
                    </div>
                </React.Fragment>
            );
        case 'productListHead':
            return (
                <React.Fragment>
                    <Block w={250} h={20} mt={25} mb={10}/>

                    <Block type="wrap" mt={16}>
                        <Block w={90} h={19} mr={10}/>
                        <Block w={90} h={19} mr={10}/>
                        <Block w={90} h={19}/>
                    </Block>
                </React.Fragment>
            );
        default:
            return null;
    }
};

export default Placeholder;



// WEBPACK FOOTER //
// ./src/modules/Placeholder/Placeholder.tsx